export const dateModalStyles = {
  root: {
    alignment: 'center',
    backgroundColor: 'white',
    display: 'flex',
    flexDirection: 'column',
  },
};
